import React, { useEffect } from "react";

export default function ProductDeleteConfirmationDialog({
  productName,
  model,
  error,
  deleting,
  onCancel,
  onConfirm,
  confirmButtonRef,
}) {
  const idPrefix = productName.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  useEffect(() => {
    confirmButtonRef?.current?.focus();
  }, [confirmButtonRef]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <section
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={`delete-${idPrefix}-title`}
        aria-describedby={`delete-${idPrefix}-description`}
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl"
      >
        <h2
          id={`delete-${idPrefix}-title`}
          className="mb-3 text-xl font-semibold text-gray-900"
        >
          Delete {productName}?
        </h2>
        <p id={`delete-${idPrefix}-description`} className="text-gray-700">
          Permanently delete <strong>{model}</strong>? This cannot be undone.
        </p>
        {error && (
          <p
            className="mt-3 rounded bg-red-100 p-3 text-sm text-red-800"
            role="alert"
          >
            {error}
          </p>
        )}
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={deleting}
            className="rounded border border-gray-300 px-4 py-2 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            ref={confirmButtonRef}
            onClick={onConfirm}
            disabled={deleting}
            className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-800 disabled:opacity-50"
          >
            {deleting ? "Deleting…" : `Delete ${productName}`}
          </button>
        </div>
      </section>
    </div>
  );
}
